import { Component, ElementRef, Input, forwardRef, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IMessage, IProcedure } from '../interactivity-editor/redux/timeline-data.model';
import { TranslateService } from '@ngx-translate/core';
import { bbGenerateShortId } from '../../../shared/utils/bbGenerateShortId.util';


@Component({
	selector: 'bb-event-handlers',
	templateUrl: './bb-event-handlers.component.html',
	styleUrls: ['./bb-event-handlers.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BbEventHandlersComponent),
		multi: true
	}]

})

export class BbEventHandlersComponent implements ControlValueAccessor, OnInit, OnChanges {
	@Input() disabled = false;

	el: HTMLElement;
	modelValue: IMessage[];

	eventName: string;
	eventList: any[] = ('started play playing pause ended loadedclipdata modechange phasechange statechange durationchange canplay resized error timeupdate' +
		' seeked loadedmetadata inview outview assetselected loadeddata mouseover1s mouseover2s mouseover3s mouseover4s mouseover5s')
		.split(' ')
		.map((eventName) => ({
			label: this.translate.instant('PLAYER_' + eventName.toUpperCase()),
			value: 'player_' + eventName
		}));

	constructor(
		private _eref: ElementRef,
		private translate: TranslateService
	) {
		this.el = this._eref.nativeElement;
	}

	ngOnInit() { }

	ngOnChanges(changes: SimpleChanges) { }

	onParameterChanged(value: string, i: number) {
		this.propagateChange(this.modelValue);
	}

	onEventSelected(val: any) {
		const procedure: IProcedure = {
			id: bbGenerateShortId(),
			condition: {
				variables: null,
				expression: ''
			},
			actions: [{
				id: bbGenerateShortId(),
				entity: 'javascript',
				command: '',
				parameters: [{
					name: 'p_0',
					value: ''
				}]
			}],
			else_actions: [],
			type: 'simple'
		};
		if (!this.modelValue) {
			this.modelValue = [];
		}
		this.modelValue.push({
			name: val.value,
			procedures: [procedure]
		});
		this.propagateChange(this.modelValue);
	}

	removeMessage(message: IMessage) {
		this.modelValue.splice(this.modelValue.indexOf(message), 1);
		this.propagateChange(this.modelValue);
	}

	addAction(procedure: IProcedure) {
		procedure.actions.push({
			id: bbGenerateShortId(),
			entity: 'javascript',
			command: '',
			parameters: [{
				name: 'p_0',
				value: ''
			}]
		});
		this.propagateChange(this.modelValue);
	}

	// ControlValueAccessor fields:
	writeValue(value: IMessage[]) {
		if (value) {
			this.modelValue = value;
		} else {
			this.modelValue = [];
		}
	}

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	propagateChange = (_: any) => { };

	registerOnTouched() { }
}
